import React, { useEffect, useState } from "react";
import { getData, searchTable } from "../Tools/helpers";

import TableListStudent from "./components/TableListStudent";
import { PageTitle, SearchInput } from "../components/PageHeader";

const Payment = () => {
  const [dataTable, setDataTable] = useState([]);

  const routeForm = "Student-university";

  const getStudents = async () => {
    const user = await JSON.parse(localStorage.getItem("USER_IUMV"));
    const route = routeForm;
    const send = await getData(`${route}/${user.university_id}`);
    if (send.code === 200) {
      setListSearch(send.data);
      setDataTable(send.data);
    }
  };

  //BUSQUEDA
  const [fieldSearch, setFieldSearch] = useState("");
  const [listSearch, setListSearch] = useState([]);

  const setStateSearch = async (e) => {
    console.log(e.target.value);
    await setFieldSearch(e.target.value);
    const resulData = await searchTable(dataTable, e.target.value, "name", "curp");
    setListSearch(resulData);
  };

  useEffect(() => {
    getStudents();
  }, []);

  const FieldsCustomTable = [
    { name: "student_id", label: "ID", required: "true" },
    { name: "name", label: "Nombre completo", required: "true" },
    { name: "email", label: "Correo", required: "true" },
    { name: "curp", label: "Curp", required: "true" },
    { name: "university_name", label: "Campus", required: "true" },
    { name: "career_name", label: "Carrera", required: "true" },
    { name: "start_date", label: "Fecha inicio", required: "false" },
    { name: "end_date", label: "Fecha Termino", required: "false" },
  ];

  return (
    <div className="flex-1">
      <PageTitle>Pagos</PageTitle>
      <div className="flex-1 mb-6">
        <SearchInput
          value={fieldSearch}
          onChange={setStateSearch}
          placeholder="Buscar por nombre o CURP..."
          style={{ maxWidth: '380px' }}
        />
      </div>
      <div className="flex-1">
        <TableListStudent fields={FieldsCustomTable} data={listSearch} />
      </div>
    </div>
  );
};

export default Payment;
